import React from 'react';

import CommonHeader, { DrawerLinks, HeaderLinks, IHeaderProps } from './common';

const Header: React.FunctionComponent<IHeaderProps> = props => {
  const hLinks: HeaderLinks[] = [HeaderLinks.SupportLink];
  const dLinks: DrawerLinks[] = [
    DrawerLinks.Home,
    DrawerLinks.AccountSettings,
    DrawerLinks.AccountHistory,
    DrawerLinks.SupportLink,
    DrawerLinks.TryNewDashboard,
    DrawerLinks.Logout,
  ];

  return <CommonHeader {...props} headerLinks={hLinks} drawerLinks={dLinks} />;
};

export default Header;
